module.exports = __webpack_public_path__ + "img/kr-product-card3-item3-step4.87112a0.png";